<template>
  <div>
    <AboutHeader />

    <div class="cta-container">
      <SignUpCtaSection title="Empowering Businesses with Automated Mobile App Security" />
    </div>

    <div class="line-wrapper">
      <hr class="line" />
    </div>

    <AboutMain :is-authenticated="isAuthenticated" />

    <div class="line-wrapper">
      <hr class="line" />
    </div>
    <AboutFooter />
  </div>
</template>
<script>
import AboutHeader from '../components/about/AboutHeader';
import AboutMain from '../components/about/AboutMain';
import AboutFooter from '../components/about/AboutFooter';
import SignUpCtaSection from '../components/@shared/SignUpCtaSection.vue';

export default {
  components: {
    AboutHeader,
    AboutMain,
    AboutFooter,
    SignUpCtaSection,
  },
  computed: {
    isAuthenticated: {
      get() {
        return this.$auth.isAuthenticated;
      },
    },
  },
};
</script>
<style scoped>
.cta-container {
  margin: 2rem auto 0;
  max-width: 625px;
}

.line-wrapper {
  margin: 95px 0;
  width: 100%;
  display: flex;
  justify-content: center;
}

.line {
  width: 90%;
  background-color: black;
}

@media (max-width: 840px) {
  .line {
    width: 90%;
  }

  .line-wrapper {
    display: flex;
    justify-content: center;
    margin: 50px 0;
    width: 100%;
  }
}
</style>
